module.exports = __webpack_public_path__ + "img/LNB_store.143eb46a.svg";